import '../style/more.scss'
import { isFunction, isObject } from 'lodash'

export default {
  functional: true,
  render (h, context) {
    const props = context.props
    const [children] = context.slots().default || []
    let number = props.number
    let checked = false
    // 自定义更多
    if (props.customMoreOption) {
      if (isFunction(props.customMoreOption)) {
        const result = props.customMoreOption(props) || {}
        checked = result.checked
        number = result.number
      } else if (isObject(props.customMoreOption)) {
        checked = props.customMoreOption.checked
        number = props.customMoreOption.number
      }
    } else {
      checked = props.data && props.data.length && props.data.some(ele => {
        return props.showCheckbox ? (ele && ele.checked) : (ele && props.selectedKey === ele.key)
      })
    }
    const popperClass = 'kye-data-statistic-more ' + (props.morePopoverAttrs.props ? (props.morePopoverAttrs.props.popperClass || '') : (props.morePopoverAttrs.popperClass || ''))
    const popoverAttrs = {
      props: {
        placement: 'bottom',
        width: 'auto',
        trigger: 'click',
        popperClass,
        ...(props.morePopoverAttrs ? (props.morePopoverAttrs.props || props.morePopoverAttrs) : {})
      },
      on: {
        ...(props.morePopoverAttrs ? props.morePopoverAttrs.on : {})
      },
      ref: 'pop'
    }
    return <el-popover {...popoverAttrs}>
      { children }
      <div
        slot='reference'
        class='kye-data-statistic-more-reference'
      >
        <div class='label'>{props.label}</div>
        <span class={{'checked': checked, 'number': true}}>({number})</span>
        <i class={['el-icon-arrow-down ml-4', props.arrowClass]}></i>
      </div>
    </el-popover>
  },
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-statistic/component/more.js